// Firebase Cloud Messaging (push web). Ver CLAUDE.md §8.
// Todo es opcional: si no hay config VITE_FIREBASE_* o el navegador no soporta
// push, initPush() no hace nada (la app funciona igual, sin notificaciones).
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging'

const cfg = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}
const VAPID = import.meta.env.VITE_FIREBASE_VAPID_KEY

export function firebaseConfigured(): boolean {
  return Boolean(cfg.apiKey && cfg.projectId && cfg.messagingSenderId && cfg.appId && VAPID)
}

/**
 * Pide permiso, registra el SW de mensajería y obtiene el token FCM del dispositivo.
 * Llama onToken(token) si lo consigue. Idempotente y silencioso ante fallos.
 */
export async function initPush(onToken: (token: string) => void): Promise<void> {
  try {
    if (!firebaseConfigured()) return
    if (!('serviceWorker' in navigator) || !('Notification' in window)) return
    if (!(await isSupported().catch(() => false))) return

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') return

    const app = initializeApp(cfg)
    const messaging = getMessaging(app)

    // El SW de mensajería vive en su propio scope (no choca con /sw.js). La config
    // (pública) viaja por query string para no hardcodearla en el archivo estático.
    const qs = new URLSearchParams({
      apiKey: cfg.apiKey,
      authDomain: cfg.authDomain,
      projectId: cfg.projectId,
      messagingSenderId: cfg.messagingSenderId,
      appId: cfg.appId,
    }).toString()
    const swReg = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${qs}`, {
      scope: '/firebase-cloud-messaging-push-scope',
    })

    const token = await getToken(messaging, { vapidKey: VAPID, serviceWorkerRegistration: swReg })
    if (token) onToken(token)

    // App en primer plano: mensaje SOLO-datos → mostramos UNA notificación y
    // avisamos a la campanita para que refresque la bandeja.
    onMessage(messaging, (payload) => {
      const d = (payload.data ?? {}) as Record<string, string>
      window.dispatchEvent(new CustomEvent('ds-notification'))
      if (Notification.permission === 'granted') {
        const n = new Notification(d.title || 'Hotel Depot Reparto', {
          body: d.body || '',
          icon: '/icon-192.png',
          tag: d.work_order_id || undefined,
        })
        n.onclick = () => {
          window.focus()
          if (d.url) window.location.assign(d.url)
          n.close()
        }
      }
    })
  } catch {
    /* push es best-effort: nunca romper la app por esto */
  }
}
